import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';

import Svgs from '../Svgs';
import { StaticRoutePaths } from '../ClientRoutes';
import localStorage from '../LocalStorage';

import { translations } from '../Translations';
import { getCurrentUser } from '../../Users/epics-users';
import CompanyInfoCard from './Company-details';
import { getSingleCompany } from '../../Companies/epics-companies';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

class CompanyInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingSpinner: false,
            hasCompany: false,
            companyId: '',
            companyName: '',
            pharmacyCount: '',
            address: '',
            phone: '',
            email: '',
            owner: ''
        };
    }

    componentDidMount() {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });
        getCurrentUser()
            .then(response => {
                if (typeof response.company !== 'undefined') {
                    getSingleCompany(response.company.id)
                        .then(response => {
                            this.setState({
                                loadingSpinner: false,
                                hasCompany: true,
                                companyId: response.id,
                                companyName: response.name,
                                pharmacyCount: response.pharmaciesCount,
                                address: response.address.name,
                                phone: response.phone,
                                email: response.email,
                                owner: response.ownerName
                            });
                        })
                        .catch(() => {});
                } else {
                    this.setState({
                        loadingSpinner: false,
                        hasCompany: false,
                        companyId: '',
                        companyName: '',
                        pharmacyCount: '',
                        address: '',
                        phone: '',
                        email: '',
                        owner: ''
                    });
                }
            })
            .catch(() => {
                this.setState({
                    loadingSpinner: false
                });
            });
    }

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.companies}</span>
                    </div>

                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-info-circle mr-2" />
                                    {strings.company_info}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.HOME} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>
                        {this.state.loadingSpinner ? (
                            <div className="col-11 white-bg px-5 text-center p-3">
                                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                            </div>
                        ) : (
                            <CompanyInfoCard {...this.state} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(CompanyInformation);



// WEBPACK FOOTER //
// ./src/customModules/Common/company/component-company-info.js